/**
 * Bundle discount uses line item properties (e.g. BD). When the bundle is no longer
 * complete (a line removed or qty mismatch), we strip those properties instead of
 * removing remaining products.
 *
 * Console: logs every schedule/debounce/sync step when window.__LECTRON_BUNDLE_DEBUG
 * is not false. Set window.__LECTRON_BUNDLE_DEBUG = false to silence.
 */
(function () {
  var BUNDLE_KEYS = ['BD', '_bundle_group', '_bundle_qty', '_bundle_variant_ids'];

  function bundleDebugEnabled() {
    return typeof window !== 'undefined' && window.__LECTRON_BUNDLE_DEBUG !== false;
  }

  function bundleLog() {
    if (!bundleDebugEnabled()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[LectronBundle]');
    console.log.apply(console, args);
  }

  var runSeq = 0;
  var schedulePendingCount = 0;

  function randomGroupId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'bg_' + Date.now() + '_' + Math.random().toString(36).slice(2, 11);
  }

  function buildBundleLineItemProperties(discountRate, mainVariantId, addonVariantIds, qty) {
    var ids = [Number(mainVariantId)]
      .concat((addonVariantIds || []).map(function (x) { return Number(x); }))
      .filter(function (n) { return n; })
      .sort(function (a, b) { return a - b; });
    return {
      BD: String(discountRate),
      _bundle_group: randomGroupId(),
      _bundle_qty: String(qty),
      _bundle_variant_ids: ids.join(','),
    };
  }

  function parseExpectedVariantIds(variantIdsCsv) {
    return (variantIdsCsv || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean)
      .map(Number);
  }

  function getQtyByVariant(groupItems) {
    var qtyByVariant = {};
    for (var i = 0; i < groupItems.length; i++) {
      var it = groupItems[i];
      var vid = it.variant_id;
      qtyByVariant[vid] = (qtyByVariant[vid] || 0) + it.quantity;
    }
    return qtyByVariant;
  }

  function getMatchedBundleQty(groupItems, variantIdsCsv) {
    var expected = parseExpectedVariantIds(variantIdsCsv);
    if (!expected.length) return 0;
    var qtyByVariant = getQtyByVariant(groupItems);
    var minQty = Infinity;
    for (var i = 0; i < expected.length; i++) {
      var qty = Number(qtyByVariant[expected[i]] || 0);
      minQty = Math.min(minQty, qty);
    }
    if (!Number.isFinite(minQty) || minQty < 1) return 0;
    return minQty;
  }

  function stripBundleProperties(props) {
    var clean = {};
    if (!props) return clean;
    Object.keys(props).forEach(function (key) {
      if (BUNDLE_KEYS.indexOf(key) === -1 && props[key] != null && String(props[key]) !== '') {
        clean[key] = props[key];
      }
    });
    return clean;
  }

  function clearKeysPresent(props) {
    var clear = {};
    if (!props) return clear;
    for (var i = 0; i < BUNDLE_KEYS.length; i++) {
      var k = BUNDLE_KEYS[i];
      if (Object.prototype.hasOwnProperty.call(props, k) && props[k] != null && String(props[k]) !== '') {
        clear[k] = '';
      }
    }
    return clear;
  }

  function fetchCartJson() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) return null;
      return r.json();
    });
  }

  function runRepairBundleGroups(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return Promise.resolve({ updates: [], addPlainItems: [] });
    }

    var byGroup = {};
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var p = it.properties || {};
      var g = p._bundle_group;
      if (!g || p.BD == null || String(p.BD) === '') continue;
      if (!byGroup[g]) byGroup[g] = [];
      byGroup[g].push(it);
    }

    var updates = [];
    var addPlainItems = [];
    Object.keys(byGroup).forEach(function (g) {
      var groupItems = byGroup[g];
      var first = groupItems[0];
      var fp = first.properties || {};
      var matchedQty = getMatchedBundleQty(groupItems, fp._bundle_variant_ids);

      if (matchedQty < 1) {
        for (var j = 0; j < groupItems.length; j++) {
          var unmatchedItem = groupItems[j];
          var strippedProps = stripBundleProperties(unmatchedItem.properties);
          var hadBundleKeys = clearKeysPresent(unmatchedItem.properties);
          if (Object.keys(hadBundleKeys).length) {
            updates.push({ key: unmatchedItem.key, quantity: unmatchedItem.quantity, properties: strippedProps });
          }
        }
        return;
      }

      for (var k = 0; k < groupItems.length; k++) {
        var item = groupItems[k];
        if (item.quantity > matchedQty) {
          var extraQty = item.quantity - matchedQty;
          addPlainItems.push({ id: item.variant_id, quantity: extraQty });
          updates.push({ key: item.key, quantity: matchedQty, properties: item.properties || {} });
        }
      }
    });

    return Promise.resolve({ updates: updates, addPlainItems: addPlainItems });
  }

  function executeUpdates(updates, addPlainItems, logLabel) {
    var label = logLabel || 'updates';
    var totalSteps = updates.length + (addPlainItems.length ? 1 : 0);
    var step = 0;
    var chain = Promise.resolve();
    updates.forEach(function (u) {
      chain = chain.then(function () {
        step += 1;
        var t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
        bundleLog(label + ' cart/change step', step + '/' + totalSteps, 'key=', u.key, 'qty=', u.quantity);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: u.key,
            quantity: u.quantity,
            properties: u.properties,
          }),
        }).then(function (res) {
          var t1 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
          bundleLog(label + ' cart/change done', step + '/' + totalSteps, 'ok=', res.ok, '(' + Math.round(t1 - t0) + 'ms)');
          return res;
        });
      });
    });
    if (addPlainItems.length) {
      chain = chain.then(function () {
        step += 1;
        var t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
        bundleLog(label + ' cart/add step', step + '/' + totalSteps, 'items=', addPlainItems.length);
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: addPlainItems }),
        }).then(function (res) {
          var t1 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
          bundleLog(label + ' cart/add done', 'ok=', res.ok, '(' + Math.round(t1 - t0) + 'ms)');
          return res;
        });
      });
    }
    return chain;
  }

  function refreshCartUi() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {}
    if (typeof window.__cartDrawerRefresh === 'function') {
      try {
        return window.__cartDrawerRefresh(false);
      } catch (e2) {}
    }
  }

  var syncing = false;
  var syncDebounceTimer = null;
  var SYNC_DEBOUNCE_MS = 50;

  function syncBundleDiscountLineItems() {
    if (syncing) {
      bundleLog('sync skipped — already running');
      return Promise.resolve();
    }
    syncing = true;

    runSeq += 1;
    var runId = runSeq;
    var syncStart = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();

    bundleLog('sync #' + runId + ' start');

    var didMutate = false;

    return fetchCartJson()
      .then(function (cart) {
        var n = cart && cart.items ? cart.items.length : 0;
        bundleLog('sync #' + runId + ' GET /cart.js →', n, 'line(s)');
        if (!cart || !cart.items) {
          return Promise.resolve(null);
        }
        return runRepairBundleGroups(cart).then(function (repair) {
          var hasRepair = repair.updates.length > 0 || repair.addPlainItems.length > 0;
          bundleLog(
            'sync #' + runId + ' repair:',
            hasRepair ? 'run' : 'skip',
            '(' + repair.updates.length + ' change(s),',
            repair.addPlainItems.length,
            'plain add branch(es))'
          );
          if (!hasRepair) {
            return Promise.resolve(cart);
          }
          didMutate = true;
          return executeUpdates(repair.updates, repair.addPlainItems, 'repair#' + runId).then(function () {
            return fetchCartJson();
          });
        });
      })
      .then(function () {
        if (didMutate) {
          bundleLog('sync #' + runId + ' refreshCartUi()');
          refreshCartUi();
        } else {
          bundleLog('sync #' + runId + ' no cart mutations — skip drawer refresh');
        }
        var syncEnd = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
        bundleLog('sync #' + runId + ' end', '(' + Math.round(syncEnd - syncStart) + 'ms total)');
      })
      .finally(function () {
        syncing = false;
      });
  }

  function scheduleSync(source) {
    schedulePendingCount += 1;
    bundleLog(
      'scheduleSync',
      typeof source === 'string' ? '"' + source + '"' : '',
      '→ debounce',
      SYNC_DEBOUNCE_MS + 'ms',
      '(coalesced requests:',
      schedulePendingCount + ')'
    );
    if (syncDebounceTimer) {
      clearTimeout(syncDebounceTimer);
      bundleLog('scheduleSync → reset timer (only the last event in', SYNC_DEBOUNCE_MS + 'ms runs)');
    }
    syncDebounceTimer = setTimeout(function () {
      syncDebounceTimer = null;
      schedulePendingCount = 0;
      bundleLog('debounce fired → run syncBundleDiscountLineItems()');
      syncBundleDiscountLineItems();
    }, SYNC_DEBOUNCE_MS);
  }

  window.LectronBundleCart = {
    BUNDLE_KEYS: BUNDLE_KEYS,
    buildBundleLineItemProperties: buildBundleLineItemProperties,
    syncBundleDiscountLineItems: syncBundleDiscountLineItems,
  };

  document.addEventListener('cart:updated', function () {
    scheduleSync('cart:updated');
  });
  document.addEventListener('cart:change', function () {
    scheduleSync('cart:change');
  });
  document.addEventListener('theme:cart-drawer:updated', function () {
    scheduleSync('theme:cart-drawer:updated');
  });

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var p = origFetch.apply(this, args);
    var url = typeof args[0] === 'string' ? args[0] : '';
    if (
      typeof url === 'string' &&
      (url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/add') !== -1)
    ) {
      return p.then(function (res) {
        if (res.ok) {
          var shortUrl = url.split('?')[0];
          scheduleSync('fetch ' + shortUrl);
        }
        return res;
      });
    }
    return p;
  };

  if (window.location.pathname.indexOf('/cart') !== -1) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scheduleSync('DOMContentLoaded /cart');
      });
    } else {
      scheduleSync('initial /cart');
    }
  }
})();
